import type { SVGProps } from 'react'
import { type CustomSvgName, isCustomSvg } from '../svg-config'
import { CustomSvg } from './custom-svg'
import { Icon, type IconName } from './icon'

type Size = 'font' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export type UnifiedIconName = IconName | CustomSvgName

interface UnifiedIconProps {
	name: UnifiedIconName
	size?: Size
	className?: string
	title?: string
	children?: React.ReactNode
}

/**
 * UnifiedIcon Component
 * A wrapper that intelligently renders either a sprite Icon or a CustomSvg
 * based on the icon name provided
 */
export function UnifiedIcon({
	name,
	size = 'font',
	className,
	title,
	children,
	...props
}: UnifiedIconProps & Omit<SVGProps<SVGSVGElement>, 'name'>) {
	// Check if this is a custom SVG from public/img
	if (isCustomSvg(name)) {
		return (
			<CustomSvg
				name={name}
				size={size}
				className={className}
				title={title}
				{...props}
			>
				{children}
			</CustomSvg>
		)
	}

	// Otherwise, use the sprite-based Icon component
	return (
		<Icon
			name={name as IconName}
			size={size}
			className={className}
			title={title}
			{...props}
		>
			{children}
		</Icon>
	)
}
